export enum OperatingSystem {
	Windows,
	Mac,
	Linux,
	Android,
	iOS,
	Unknown,
}
